import { observer } from "mobx-react-lite";
import {
	RIGHT_CLICK_MENU_DATA_ATTR,
	type RightClick,
	type RightClickMenuAction,
	type RightClickMenuStore,
} from "@/components/Map/RightClickMenu/RightClickMenuStore";

interface RightClickMenuProps<TTarget> {
	rightClickMenuStore: RightClickMenuStore<TTarget>;
	actions: (click: RightClick<TTarget>) => RightClickMenuAction<TTarget>[];
}

const RightClickMenuInner = <TTarget,>({ rightClickMenuStore, actions }: RightClickMenuProps<TTarget>) => {
	const position = rightClickMenuStore.position;
	const items = position ? actions(position) : [];

	const handleSelect = (action: RightClickMenuAction<TTarget>) => {
		if (!position) return;
		action.onSelect(position);
		rightClickMenuStore.close();
	};

	if (!position || items.length === 0) return null;

	return (
		<div
			{...{ [RIGHT_CLICK_MENU_DATA_ATTR]: true }}
			className="absolute z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-[180px]"
			style={{ left: position.x, top: position.y }}
		>
			{items.map(action => (
				<button
					key={action.id}
					className="flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
					onClick={() => handleSelect(action)}
				>
					{action.icon}
					{action.label}
				</button>
			))}
		</div>
	);
};

export const RightClickMenu = observer(RightClickMenuInner) as typeof RightClickMenuInner;
